import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { InviteLinksState } from './state'
import {
    createRetentionFeatureSlice,
    createInviteLinksFeatureSlice,
    createAudienceSlice,
    createInviteLinksGroupSlice,
    createRetentionGroupsSlice,
    createMarkingModalSlice,
} from './slices'

const OMIT_FIELDS: (keyof InviteLinksState)[] = [
    'selectedLinksInviteByGroup',
    'selectedSiteLinksByGroup',
    'selectedGroups',
    'publisherError',
    'publishOptionError',
    'contractError',
    'eridError',
]

export const useInviteLinksStore = create<InviteLinksState>()(
    persist(
        (...a) => ({
            ...createRetentionFeatureSlice(...a),
            ...createInviteLinksFeatureSlice(...a),
            ...createAudienceSlice(...a),
            ...createInviteLinksGroupSlice(...a),
            ...createRetentionGroupsSlice(...a),
            ...createMarkingModalSlice(...a),
        }),
        {
            name: 'invite-links-storage',
            partialize: (state) =>
                Object.fromEntries(
                    Object.entries(state).filter(
                        ([key]) =>
                            !OMIT_FIELDS.includes(key as keyof InviteLinksState)
                    )
                ),
        }
    )
)
